'use strict';

import angular from 'angular';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function routeConfig($urlRouterProvider, $locationProvider) 
{
	'ngInject';

	$urlRouterProvider.otherwise('/');
	
	$locationProvider.html5Mode(true);
	$locationProvider.hashPrefix(''); // Para permitir compatibilidad con las rutas que vienen de la version vieja
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function translationConfig($translateProvider) 
{
	'ngInject';

	$translateProvider.useStaticFilesLoader(
	{
		files:
		[{ // HACK: Esto es una cagada hasta que tengamos un loader de webpack decente
			prefix: '/assets/locales/angular-validation-ghiscoding/',
			suffix: '.json'
		},
		{
			prefix: '/assets/locales/client/',
			suffix: '.json'
		}]
		// Add here custom app messages...
	});

	// define translation maps you want to use on startup
	$translateProvider.registerAvailableLanguageKeys(['en', 'es', 'de'], {
		'en_*': 'en',
		'es_*': 'es',
		'de_*': 'de'
	})
	.determinePreferredLanguage();

	//$translateProvider.preferredLanguage("es"); // Este no lo puedo activar porque sino no funciona el determinePreferredLanguage
	$translateProvider.fallbackLanguage('en');

	// NOTA: Si sanitize es escape, funcionan los caracteres especiales, pero no el HTML
	//       Si es sanitize, funciona el HTML pero no los caracteres especiales
	//       El caso de sanitize es debido a un bug que solucionarán, mientras tanto usar null
	//@{
	$translateProvider.useSanitizeValueStrategy(null);
	//@}

	//$translateProvider.storageKey('language');
	//$translateProvider.useCookieStorage();
	$translateProvider.useStorage('langStorage');
}

/*
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
angular.module('jcs-autoValidate').run(['defaultErrorMessageResolver', function(defaultErrorMessageResolver) {
	// passing a culture into getErrorMessages('fr-fr') will get the culture specific messages
	// otherwise the current default culture is returned.
	defaultErrorMessageResolver.setI18nFileRootPath("/libs/angular-auto-validate/js/lang");
	defaultErrorMessageResolver.setCulture(everlapsLang);

	defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
		errorMessages["validtransponder"] = "El transponder debe ser un número de 7 cifras";
	});
}]);
*/

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// http://www.webdeveasy.com/interceptors-in-angularjs-and-useful-examples/
// http://michalostruszka.pl/blog/2013/09/06/selective_http_errors_handling_in_angularjs/
export function interceptorConfig($httpProvider)
{
	'ngInject';
	//console.log("MY AUTH INTERCEPTOR LOADED");
		
	// alternatively, register the interceptor via an anonymous factory
	$httpProvider.interceptors.push(function($q, $injector, $log)
	{
		var messageService = null;
		var translate = null;

		return {
			"request": function(config)
			{
				//console.log(config);
				// do something on success
				
				return config;
			},
			"requestError": function(rejection)
			{
				// do something on error
				//console.log("RequestError");
				//console.log(rejection);
				//if (canRecover(rejection))
				//	return responseOrNewPromise

				return $q.reject(rejection);
			},
			"response": function(response)
			{
				//console.log(response);
				// do something on success

				return response;
			},
			"responseError": function(rejection)
			{
				// do something on error
				//console.log("ResponseError");
				//console.log(rejection);
				
				var code = rejection.status;

				if (code >= 500) 
				{
					if (!messageService) messageService = $injector.get('messageService');
					if (!translate) translate = $injector.get('$translate');

					var msg = rejection.data ? rejection.data : "Situación imprevista";
					messageService.Error(msg, translate.instant("WARNING"));
				}
				/*
				if (code == 401) window.location = "/userlogin"; // Unauthorized
				else if (code == 403) window.location = "/403";
				else if (code == 501) MessageService.Warning("Function is not available yet", "Function not implemented");
				else if (rejection.data.title && rejection.data.body)
				{
					if (code >= 300 && code < 300) { } // TODO: Redirect 
					else if (code >= 400 && code < 500) MessageService.Warning(rejection.data.body, rejection.data.title);
					else MessageService.Error(rejection.data.body, rejection.data.title);
				}
				else
				{
					MessageService.Error("No se ha podido completar la operación. Por favor, inténtalo de nuevo más tarde", "Error indeterminado");
				}
				*/
				
				return $q.reject(rejection);
			}
		};
	});
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function toastConfig(toastrConfig)
{
	'ngInject';
	angular.extend(toastrConfig, {
		allowHtml: false,
		progressBar: true,
		//closeButton: false,
		//closeHtml: '<button>&times;</button>',
		//extendedTimeOut: 1000,
		/*iconClasses: {
			error: 'toast-error',
			info: 'toast-info',
			success: 'toast-success',
			warning: 'toast-warning'
		},
		messageClass: 'toast-message',
		onHidden: null,
		onShown: null,
		onTap: null,
		progressBar: false,
		tapToDismiss: true,
		templates: {
			toast: 'directives/toast/toast.html',
			progressbar: 'directives/progressbar/progressbar.html'
		},
		timeOut: 5000,
		titleClass: 'toast-title',
		toastClass: 'toast'*/
	});
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function langFactory($cookies, amMoment) 
{
	'ngInject';
	return {
		put: function (name, value) {
			// El nombre de la cookie es el mismo que usa i18n en el servidor para que estén sincronizados
			var v = new Date();
			v.setDate(v.getDate() + 999);

			$cookies.put("language", value, { expires: v }); // Expira en 3 años

			// Cambiar idioma en angular-moment
			amMoment.changeLocale(value);
		},
		get: function (/*name*/) {
			return $cookies.get("language"); // NOTE: La primera vez devuelve undefined, y el idioma se resuelve por determinePreferredLanguage()
		}
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function messageService(toastr)
{
	'ngInject';

	var methods = {};

	methods.Info = function(text, title) { toastr.info(text, title); }
	methods.Warning = function(text, title) { toastr.warning(text, title); }
	methods.Success = function(text, title) { toastr.success(text, title); }
	methods.Error = function(text, title) { toastr.error(text, title); }

	return methods;
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function bootstrapValidationDecorator() 
{
	return {
		scope: {
			bootstrapValidationDecorator: '@'
		},
		restrict: 'A',
		require: '^form',
		link: function (scope, el, attrs, formCtrl) {
			scope.form = formCtrl; // no template so no need for that for now

			if (scope.bootstrapValidationDecorator && scope.bootstrapValidationDecorator !== "")
				scope.fieldName = scope.bootstrapValidationDecorator;
			else
				scope.fieldName = angular.element( el[0].querySelector("[name]") ).attr('name');
			
			scope.$watch(
				function(scope) {
					return scope.form[scope.fieldName].isErrorMessageVisible;
				},
				function( newVal, oldVal ) {
					if (newVal != oldVal)
						el.toggleClass('has-error', newVal === true);
				}
			);
		}
	};
}



// WEBPACK FOOTER //
// ./client/app/app.config.js